// extracted by mini-css-extract-plugin
module.exports = {"projectList":"projects-module--project-list--3F0hu"};